import './CreateDirectory.css'
import { Amplify, Storage } from "aws-amplify";
import awsconfig from "../aws-exports";
import { useState } from 'react';
import FolderNameInputPopUp from './FolderNameInputPopUp';
import Tooltip from '@mui/material/Tooltip';
import { BiFolderPlus } from 'react-icons/bi'
Amplify.configure(awsconfig);

function CreateDirectory(props) {

    const { /*bucketname,*/currentPath, onNewFileUpload } = props

    const [reloadAllUploadedFilesPage, setReloadAllUploadedFilesPage] = useState({})
    const [isInputOpen, setIsInputOpen] = useState(false)

    async function createFolder(foldername) {
        try {
            const response = await Storage.put(currentPath + foldername + '/', 'foldername.txt', {
                // bucket: bucketname,
                level: 'private',
                // resumable: true,
                progressCallback(progress) {
                    console.log(`Created: ${progress.loaded}/${progress.total}`);
                },
            });
            setReloadAllUploadedFilesPage(response)
            onNewFileUpload(reloadAllUploadedFilesPage)
            console.log(response);
        } catch (error) {
            console.log("Error creating folder: ", error);
        }
    }

    function decideInputPopUpOpen() {
        isInputOpen === false ? setIsInputOpen(true) : setIsInputOpen(false)
    }

    return <>
        <div className='create-folder'>
            <Tooltip title="New folder" placement='left-start'>
                <button
                    id='create-folder-button'
                    onClick={() => { decideInputPopUpOpen() }}
                ><BiFolderPlus id='create-folder-icon' /></button>
            </Tooltip>
        </div>
        <FolderNameInputPopUp isInputOpen={isInputOpen} setIsInputOpen={setIsInputOpen} createFolder={createFolder} />
    </>
}

export default CreateDirectory